import APIKit from "../APIKit";

function getMobilePlansAndMyPlans(payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const token = window.localStorage.getItem("authToken");
        if (token) {
          payload.append("auth_token", token);
        }
      } catch (e) {
      }
      
      APIKit.post("/plans_and_my_plans", payload)
        .then(async (response) => {
          try {
            resolve(response.data);
          } catch (e) {
            reject(e);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  function createMobilePaymentOrder(api, payload) {
  
    return new Promise(async (resolve, reject) => {
      try {
        const token = window.localStorage.getItem("authToken");
        if (token) {
          payload.append('auth_token', token);
        }
      } catch (e) {
      }
  
      APIKit.post('/'+api, payload)
        .then(async (response) => {
          try {
  
            resolve(response.data);
          } catch (e) {
            reject(e);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  function verifyMobilePayment(order_id) {
    return new Promise(async (resolve, reject) => {
      try {
        const formData = new FormData();
        formData.append('order_id', order_id);
        
        const token = window.localStorage.getItem("authToken");
        if (token) {
          formData.append('auth_token', token);
        }

        APIKit.post('/order_details', formData)
          .then(async (response) => {
            try {
              resolve(response.data);
            } catch (e) {
              reject(e);
            }
          })
          .catch((err) => {
            reject(err);
          });
      } catch (e) {
        reject(e);
      }
    });
  }


  export const MobilePlanService = {
    getMobilePlansAndMyPlans,
    createMobilePaymentOrder,
    verifyMobilePayment
  };